export default {
  hoverBox: {
    position: 'absolute',
    userSelect: 'none',
    boxSizing: 'border-box'
  }
};
